<template>
  <v-dialog :value="Boolean(state.current)" persistent max-width="460" :retain-focus="true" :z-index="1000000">
    <v-card v-if="state.current" rounded="xl">
      <v-card-title class="text-h6 pb-2">{{ items.length === 1 ? "Vorhandenen Lead bearbeiten?" : "Vorhandene Leads bearbeiten?" }}</v-card-title>
      <v-card-text class="pb-2">
        <p>Der Termin ist gespeichert. Bitte bestätige die Änderung {{ items.length === 1 ? "am vorhandenen Lead" : "an den vorhandenen Leads" }}.</p>
        <div class="lead-confirmation__items">
          <div v-for="item in items" :key="item.leadId" class="lead-confirmation__item">
            <strong class="d-block mb-1">{{ item.name }}</strong>
            <template v-if="item.from !== item.to">
              <span>{{ item.from }}</span>
              <v-icon small class="mx-2" aria-label="wird verschoben nach">mdi-arrow-right</v-icon>
              <strong>{{ item.to }}</strong>
            </template>
            <span v-else>Termindaten aktualisieren · {{ item.to }}</span>
          </div>
        </div>
        <p class="text-caption mt-4 mb-0">Bei Abbrechen bleibt der Lead unverändert.</p>
      </v-card-text>
      <v-card-actions class="pa-4 pt-2">
        <v-spacer />
        <v-btn text @click="finish(false)">Abbrechen</v-btn>
        <v-btn color="primary" depressed @click="finish(true)">{{ items.length === 1 ? "Lead aktualisieren" : "Leads aktualisieren" }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { leadConfirmationState, finishLeadConfirmation } from "../services/leadConfirmation"

export default {
  name: "LeadChangeConfirmation",
  data: () => ({ state: leadConfirmationState }),
  computed: {
    items() { return this.state.current ? this.state.current.items : [] },
  },
  methods: {
    finish: finishLeadConfirmation,
  },
}
</script>

<style scoped>
.lead-confirmation__items { max-height: 280px; overflow-y: auto; }
.lead-confirmation__item { padding: 12px 0; border-bottom: 1px solid rgba(128, 128, 128, .18); }
.lead-confirmation__item:last-child { border-bottom: 0; }
</style>
